import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/main/index.vue'
import Login from '@/views/login/index.vue'
import Introduction from '@/views/introduction/index.vue'
import News from '@/views/news/index.vue'
import Content from '@/views/news/content.vue'
import Policies from '@/views/policies/index.vue'
import Contacts from '@/views/contacts/index.vue'
import PageNotFound from '@/views/404.vue'
import Search from '@/views/search/index.vue'
import SearchAdvanced from '@/views/search/Advanced.vue'
import SpecimenInfo from '@/views/specimen/index.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/introduction',
    name: 'Introduction',
    component: Introduction
  },
  {
    path: '/news',
    name: 'News',
    component: News
  },
  {
    path: '/news/:id',
    name: 'Content',
    component: Content
  },
  {
    path: '/policies',
    name: 'Policies',
    component: Policies
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: Contacts
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    props: route => ({ query: route.query.q })
  },
  {
    path: '/search-advanced',
    name: 'SearchAdvanced',
    component: SearchAdvanced
  },
  {
    path: '/specimen',
    name: 'SpecimenQuery',
    component: SpecimenInfo,
    props: route => ({ query: route.query.q })
  },
  {
    path: '/specimen/:id',
    name: 'SpecimenInfo',
    component: SpecimenInfo
  },
  {
    path: '/specimen/catalog/:number',
    name: 'SpecimenInfoByCatalogNumber',
    component: SpecimenInfo
  },
  { path: "/:pathMatch(.*)*", name: 'PageNotFound', component: PageNotFound }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
  })
  router.matcher = newRouter.matcher // reset router
}

export default router
